export const assertNever = (value: never): never => {
	throw new Error(`\`assertNever\` called with: ${value}`);
};

export const assertType = <T>(v: T): T => v;
